module.exports = stackBlur;


//////////////////
// WEBPACK FOOTER
// external "stackBlur"
// module id = 404
// module chunks = 0